export default __webpack_public_path__ + "static/media/venus.1bf93c33.png";